import React from 'react';
import GrowthAndOwnershipScreen from './screens/GrowthAndOwnership/GrowthAndOwnershipScreen';

function GrowthAndOwnership() {
  return <GrowthAndOwnershipScreen />;
}

export default GrowthAndOwnership;
